import { reactive } from "vue"

export const useAreaCode = () => {
    const codeObject = reactive({
        phoneCode: "86"
    })
    return { codeObject }
}